var _defs, _rect, _image, _path, _path2, _path3, _image2, _image3, _image4, _path4, _image5, _image6, _image7, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _path14, _path15, _polygon2, _polygon3, _polygon4, _path16, _path17, _path18, _path19, _path20, _polygon5, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _line, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _line2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _polygon6, _path50, _polyline, _polygon7, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _polygon8, _polygon9, _path60, _g2, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _polygon10, _path70, _path71, _polygon11, _polygon12, _polygon13, _path72, _path73, _path74, _ellipse, _path75, _polygon14, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _line3, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _line4, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _polygon15, _path106, _polyline2, _polygon16, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _polygon17, _polygon18, _path116;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11C(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168.55 230.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{fill:#231f20;}.cls-199,.cls-200,.cls-3{fill-rule:evenodd;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#fec61b;}.cls-6{fill:#fec51b;}.cls-7{fill:#fdc41b;}.cls-8{fill:#fdc31b;}.cls-9{fill:#fdc21b;}.cls-10{fill:#fcc11b;}.cls-11{fill:#fcc01b;}.cls-12{fill:#fcbf1b;}.cls-13{fill:#fbbe1b;}.cls-14{fill:#fbbd1b;}.cls-15{fill:#fabc1b;}.cls-16{fill:#fabb1b;}.cls-17{fill:#faba1b;}.cls-18{fill:#f9b91b;}.cls-19{fill:#f9b81b;}.cls-20{fill:#f9b71b;}.cls-21{fill:#f8b61b;}.cls-22{fill:#f8b51b;}.cls-23{fill:#f8b41b;}.cls-24{fill:#f7b31b;}.cls-25{fill:#f7b21b;}.cls-26{fill:#f7b11b;}.cls-27{fill:#f6b01b;}.cls-28{fill:#f6af1b;}.cls-29{fill:#f6ae1b;}.cls-30{fill:#f5ad1b;}.cls-31{fill:#f5ac1b;}.cls-32{fill:#f4ab1b;}.cls-33{fill:#f4aa1b;}.cls-34{fill:#f4a91b;}.cls-35{fill:#f3a81b;}.cls-36{fill:#f3a71b;}.cls-37{fill:#f3a61b;}.cls-38{fill:#f2a51b;}.cls-39{fill:#f2a41b;}.cls-40{fill:#f2a31b;}.cls-41{fill:#f1a21b;}.cls-42{fill:#f1a11b;}.cls-43{fill:#f1a01b;}.cls-44{fill:#f09f1b;}.cls-45{fill:#f09e1b;}.cls-46{fill:#f09d1b;}.cls-47{fill:#ef9c1b;}.cls-48{fill:#ef9b1b;}.cls-49{fill:#ef9a1b;}.cls-50{fill:#ee991b;}.cls-51{fill:#ee981b;}.cls-52{fill:#ed971b;}.cls-53{fill:#ed961b;}.cls-54{fill:#ed951b;}.cls-55{fill:#ec941b;}.cls-56{fill:#ec931b;}.cls-57{fill:#ec921b;}.cls-58{fill:#eb911b;}.cls-59{fill:#eb901b;}.cls-60{fill:#eb8f1b;}.cls-61{fill:#ea8e1b;}.cls-62{fill:#ea8d1b;}.cls-63{fill:#ea8c1b;}.cls-64{fill:#e98b1b;}.cls-65{fill:#e98a1b;}.cls-66{fill:#e9891b;}.cls-67{fill:#e8881b;}.cls-68{fill:#e8871b;}.cls-69{fill:#e7861b;}.cls-70{fill:#e7851b;}.cls-71{fill:#e7841b;}.cls-72{fill:#e6831b;}.cls-73{fill:#e6821b;}.cls-74{fill:#e6811b;}.cls-75{fill:#e5801b;}.cls-76{fill:#e57f1b;}.cls-77{fill:#e57e1b;}.cls-78{fill:#e47d1b;}.cls-79{fill:#e47c1b;}.cls-80{fill:#e47b1b;}.cls-81{fill:#e37a1b;}.cls-82{fill:#e3791b;}.cls-83{fill:#e3781b;}.cls-84{fill:#e2771b;}.cls-85{fill:#e2761b;}.cls-86{fill:#e1751b;}.cls-87{fill:#e1741b;}.cls-88{fill:#e1731b;}.cls-89{fill:#e0721b;}.cls-90{fill:#e0711b;}.cls-91{fill:#e0701b;}.cls-92{fill:#df6f1b;}.cls-93{fill:#df6e1b;}.cls-94{fill:#df6c1b;}.cls-95{fill:#de6b1b;}.cls-96{fill:#de6a1b;}.cls-97{fill:#de691b;}.cls-98{fill:#dd681b;}.cls-99{fill:#dd671b;}.cls-100{fill:#dd661b;}.cls-101{fill:#dc651b;}.cls-102{fill:#dc641b;}.cls-103{fill:#db631b;}.cls-104{fill:#db621b;}.cls-105{fill:#db611b;}.cls-106{fill:#da601b;}.cls-107{fill:#da5f1b;}.cls-108{fill:#da5e1b;}.cls-109{fill:#d95d1b;}.cls-110{fill:#d95c1b;}.cls-111{fill:#d95b1b;}.cls-112{fill:#d85a1b;}.cls-113{fill:#d8591b;}.cls-114{fill:#d8581b;}.cls-115{fill:#d7571b;}.cls-116{fill:#d7561b;}.cls-117{fill:#d7551b;}.cls-118{fill:#d6541b;}.cls-119{fill:#d6531b;}.cls-120{fill:#d5521b;}.cls-121{fill:#d5511b;}.cls-122{fill:#d5501b;}.cls-123{fill:#d44f1b;}.cls-124{fill:#d44e1b;}.cls-125{fill:#d44d1b;}.cls-126{fill:#d34c1b;}.cls-127{fill:#d34b1b;}.cls-128{fill:#d34a1b;}.cls-129{fill:#d2491b;}.cls-130{fill:#d2481b;}.cls-131{fill:#d2471b;}.cls-132{fill:#d1461b;}.cls-133{fill:#d1451b;}.cls-134{fill:#d1441b;}.cls-135{fill:#d0431b;}.cls-136{fill:#d0421b;}.cls-137{fill:#d0411b;}.cls-138{fill:#cf401b;}.cls-139{fill:#cf3f1b;}.cls-140{fill:#ce3e1b;}.cls-141{fill:#ce3d1b;}.cls-142{fill:#ce3c1b;}.cls-143{fill:#cd3b1b;}.cls-144{fill:#cd3a1b;}.cls-145{fill:#cd391b;}.cls-146{fill:#cc381b;}.cls-147{fill:#cc371b;}.cls-148{fill:#cc361b;}.cls-149{fill:#cb351b;}.cls-150{fill:#cb341b;}.cls-151{fill:#cb331b;}.cls-152{fill:#ca321b;}.cls-153{fill:#ca311b;}.cls-154{fill:#ca301b;}.cls-155{fill:#c92f1b;}.cls-156{fill:#c92e1b;}.cls-157{fill:#c82d1b;}.cls-158{fill:#c82c1b;}.cls-159{fill:#c82b1b;}.cls-160{fill:#c72a1b;}.cls-161{fill:#c7291b;}.cls-162{fill:#c7281b;}.cls-163{fill:#c6271b;}.cls-164{fill:#c6261b;}.cls-165{fill:#c6251b;}.cls-166{fill:#c5241b;}.cls-167{fill:#c5231b;}.cls-168{fill:#c5221b;}.cls-169{fill:#c4211b;}.cls-170{fill:#c4201b;}.cls-171{fill:#c41f1b;}.cls-172{fill:#c31e1b;}.cls-173{fill:#c31d1b;}.cls-174{fill:#c21c1b;}.cls-175{fill:#c21b1b;}.cls-176{fill:#c21a1b;}.cls-177{fill:#c1191b;}.cls-178{fill:#c1181b;}.cls-179{fill:#c1171b;}.cls-180{fill:#c0161b;}.cls-181{fill:#c0151b;}.cls-182{fill:url(#linear-gradient);}.cls-183{fill:url(#linear-gradient-2);}.cls-184,.cls-200{fill:#5f6062;}.cls-185{fill:#fde4e0;}.cls-186{fill:url(#linear-gradient-3);}.cls-187{fill:#5c7782;}.cls-188{fill:url(#linear-gradient-4);}.cls-189{fill:#fdddc5;}.cls-190,.cls-199{fill:#fff;}.cls-191{fill:url(#linear-gradient-5);}.cls-192{fill:#d4872f;}.cls-193{fill:url(#linear-gradient-6);}.cls-194{fill:url(#linear-gradient-7);}.cls-195{fill:url(#linear-gradient-8);}.cls-196{fill:url(#linear-gradient-9);}.cls-197{fill:url(#linear-gradient-10);}.cls-198{fill:#6f7173;}.cls-201{fill:url(#linear-gradient-11);}.cls-202{fill:url(#linear-gradient-12);}.cls-203{fill:url(#linear-gradient-13);}.cls-204{fill:url(#linear-gradient-14);}.cls-205{clip-path:url(#clip-path-2);}.cls-206{fill:url(#linear-gradient-15);}.cls-207{fill:url(#linear-gradient-16);}.cls-208{fill:url(#linear-gradient-17);}.cls-209{fill:url(#linear-gradient-18);}.cls-210{fill:url(#linear-gradient-19);}.cls-211{fill:url(#linear-gradient-20);}.cls-212{fill:url(#linear-gradient-21);}.cls-213{fill:url(#linear-gradient-22);}.cls-214{fill:url(#linear-gradient-23);}.cls-215{fill:url(#linear-gradient-24);}.cls-216{fill:url(#linear-gradient-25);}.cls-217{fill:url(#linear-gradient-26);}.cls-218{fill:url(#linear-gradient-27);}.cls-219{fill:url(#linear-gradient-28);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.9,
    y1: 30.42,
    x2: 70.04,
    y2: 88.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 520.77,
    y1: 158.96,
    x2: 466.77,
    y2: 198.96,
    gradientTransform: "matrix(-0.83, -0.56, -0.56, 0.83, 556.05, 192.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 539.15,
    y1: 22.37,
    x2: 502.64,
    y2: 27.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 615.99, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 102.07,
    y1: 14.63,
    x2: 102.07,
    y2: 65.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 502.95,
    y1: 74.64,
    x2: 535.97,
    y2: 74.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 615.99, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee492f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94070a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 503.84,
    y1: 30.38,
    x2: 502.21,
    y2: 38.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 615.99, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 537.04,
    y1: 81.03,
    x2: 538.12,
    y2: 84.33,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 541.32,
    y1: 54.7,
    x2: 555.85,
    y2: 98.74,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 503.44,
    y1: 61.63,
    x2: 515.2,
    y2: 97.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 542.13,
    y1: 37.13,
    x2: 538.63,
    y2: 18.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 515.83,
    y1: 42.11,
    x2: 512.33,
    y2: 23.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 532.61,
    y1: 105.35,
    x2: 582.61,
    y2: 105.35,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 579.78,
    y1: 109.54,
    x2: 588.28,
    y2: 109.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 575.78,
    y1: 110.6,
    x2: 580.95,
    y2: 110.6,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 555.6,
    y1: 52.46,
    x2: 565.28,
    y2: 52.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.55,
    y1: 197.8,
    x2: 97.42,
    y2: 140.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 212.57,
    y1: -207.05,
    x2: 158.57,
    y2: -167.05,
    gradientTransform: "matrix(0.83, 0.56, 0.56, -0.83, 71.57, -95.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 79,
    y1: -108.84,
    x2: 42.48,
    y2: -103.55,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 42.79,
    y1: -56.57,
    x2: 75.81,
    y2: -56.57,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 43.68,
    y1: -100.83,
    x2: 42.05,
    y2: -92.7,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 76.88,
    y1: -50.18,
    x2: 77.97,
    y2: -46.88,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 81.16,
    y1: -76.51,
    x2: 95.69,
    y2: -32.47,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 43.29,
    y1: -69.58,
    x2: 55.04,
    y2: -33.96,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 75.96,
    y1: -103.38,
    x2: 44.94,
    y2: -98.89,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 81.97,
    y1: -94.07,
    x2: 78.47,
    y2: -112.57,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 55.67,
    y1: -89.1,
    x2: 52.17,
    y2: -107.6,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 72.46,
    y1: -25.85,
    x2: 122.45,
    y2: -25.85,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 119.62,
    y1: -21.66,
    x2: 128.12,
    y2: -21.66,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 115.62,
    y1: -20.61,
    x2: 120.79,
    y2: -20.61,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 95.44,
    y1: -78.75,
    x2: 105.12,
    y2: -78.75,
    gradientTransform: "matrix(1, 0, 0, -1, 11.63, 97.02)",
    xlinkHref: "#linear-gradient-2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1572.67,
    y: -284.96,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(7.79 5.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACbklEQVR4Xu3VMW4DMQwAQeqQ/39ZrnKxjQtcnLeb6USwXFBr7z0XLofwwboa/ry9xcUdz/2cwR3/LMBdZ0+/kQmMzDECo7NnXr9LSIiMnMiobZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRkRMZOZGRExk5kZETGTmRUVsiIycycsfMrE9LcIdLRmnN/EXmmvFtZ1PPl0xofMtLSw9M7Q2xzL/sRgAAAABJRU5ErkJggg=="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.94,16.52v-.59h9.37v.59h-.79a2.34,2.34,0,0,0-1.95.79,5,5,0,0,0-.38,2.49V30.49a12.27,12.27,0,0,1-.55,4,6.24,6.24,0,0,1-1.86,2.67,4.7,4.7,0,0,1-3.19,1.13,3.55,3.55,0,0,1-2.39-.75,2.22,2.22,0,0,1-.87-1.71,1.67,1.67,0,0,1,.4-1.2,1.79,1.79,0,0,1,1.25-.5,1.43,1.43,0,0,1,.92.34,5.43,5.43,0,0,1,1,1.81q.38.87,1,.87a1,1,0,0,0,.81-.53,3.47,3.47,0,0,0,.38-1.89V19.8a7.3,7.3,0,0,0-.21-2.2,1.5,1.5,0,0,0-.68-.69,2.94,2.94,0,0,0-1.47-.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.62,209.12v.6h-9.37v-.6H135a2.31,2.31,0,0,0,2-.79,4.86,4.86,0,0,0,.39-2.48V195.16a12.26,12.26,0,0,1,.54-4,6.24,6.24,0,0,1,1.86-2.67,4.73,4.73,0,0,1,3.19-1.14,3.55,3.55,0,0,1,2.39.75,2.22,2.22,0,0,1,.87,1.72,1.59,1.59,0,0,1-.4,1.19,1.74,1.74,0,0,1-1.24.5,1.39,1.39,0,0,1-.93-.34,5.23,5.23,0,0,1-1-1.8c-.25-.58-.57-.87-1-.87a1,1,0,0,0-.82.53,3.43,3.43,0,0,0-.38,1.89v14.93a7.17,7.17,0,0,0,.21,2.19,1.52,1.52,0,0,0,.68.7,3,3,0,0,0,1.47.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.3,49.28a3.2,3.2,0,0,0-2.21.88l-.34-.36a3.23,3.23,0,1,0-2.93,0l-.36.35a3.22,3.22,0,1,0,1,2.34v-.06c.4.38.87,1.56-.12,5.3H23.2c-1-3.74-.51-4.92-.12-5.3v.06a3.23,3.23,0,1,0,3.22-3.22Z"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(14.79 49.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQIW0XOy2rCQABA0ZMhPoiK+Ae+WqX//y1FQVAULMXgRlOsmTiuxLs9m5ullCxm8zQcjZzLEmx22wwCdItCCEHR64P5eJIg/1os0/TjU6vTFuva+VT6/TmC8L1eZfCIjSY2oNcfgBz+qkreytX32v/tprpe3ng87MUYvXoNPQFaRzKQ3cY72AAAAABJRU5ErkJggg=="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(22.79 49.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVQIWzXOuxHCMBAA0T1/yJBNBf72wDgF+q/AM3YDQpkUoPMRgAt4OytmBsByXyznD8F71n0TgALg+XjZtXG4pkVEmPvBAGTqeuvGCXdrObIS3p4UI8F7ijNxZEVVqesLAOu+SQWQYqSsSjQrKf0UgJgZ8zAa/7FTAXwB8zw9s/zssBAAAAAASUVORK5CYII="
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 6,
    transform: "translate(18.79 43.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbUlEQVQIW12JTQqCABQGRxEUwr82opuMjA5Q3v8iQV1AQoL3QhefC23jwCyGQRKSuHVXXU6t/h1Ior8/xIab8XMn7NqzsrygqhuquiFOEgBCdhTlcR3P9ytwN9w23TikKRHAdxyZpwmAzzAAsAAMFDJ8AHkoTQAAAABJRU5ErkJggg=="
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.31,175.29a3.25,3.25,0,0,0,2.22-.88l.34.35a3.22,3.22,0,1,0,2.93,0l.35-.35a3.23,3.23,0,1,0-1-2.34v.07c-.4-.38-.87-1.57.12-5.3h-1.85c1,3.73.51,4.92.11,5.3a.15.15,0,0,0,0-.07,3.23,3.23,0,1,0-3.23,3.23Z"
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 6,
    transform: "translate(142.79 169.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVQIW13BQQ6DIBRAwfcJFCQRaTxAMfX+V2natYkeQOPK0A3QfWfk+UhNKUWtlfs4ch4Hy7aKFhFCjPRhwNwMYYgAaOsc1jo67zHGUEphTlNT35wptfBPA5z7Tr4uOu/JObNsq0hrjTlNDaAPgdfnLQA/uIIne3AOThoAAAAASUVORK5CYII="
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 6,
    transform: "translate(133.79 169.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVQIW13KPQrCUBAA4dnsim9fNNEbJJADqPe/gmIpGPAHLEPE2rBWWjjdByMRQde0UahSr9aICK/nyKk/iwHksmRRVbhn1BSbGQAGME8J94znjKoyvScACoBxGPiva9qwLx73G8u6RlVJ7vTXi0hE/O7dZhuCsD8eBOADQ5QelFfe7/AAAAAASUVORK5CYII="
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 7,
    transform: "translate(138.79 174.36)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAYAAAArkDztAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQIW13OzQqCQBSA0W9+EsZxSAjXKfn+b1ItowgylDZFVNqye1u16TzBMaoKQFs3CnDsTgbArJa1WueYlyUAIsJ6uzHeec+iqgghJ8TI/XYFwMdYUKRECDnWO4qUaOtG7ev54NL3vKcJFKZxZJZlWAAVQVUZzh3yEXaHvTG/1b8vmxgwrX1wFhQAAAAASUVORK5CYII="
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.65,61.93,70,88.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.96,
    y: 74.75,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -27.4, 98.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 62.7,
    y: 74.57,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.37 98) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "86.86 61.4 69.25 87.52 69.51 87.7 87.12 61.58 86.86 61.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 62.17,
    y: 74.21,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.3 97.41) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 61.91,
    y: 74.03,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -27.27, 97.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "86.06 60.87 68.45 86.99 68.72 87.16 86.33 61.05 86.06 60.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 61.38,
    y: 73.68,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.21 96.51) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 61.11,
    y: 73.5,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.18 96.22) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.85,
    y: 73.32,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.15 95.92) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 60.59,
    y: 73.14,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.12 95.62) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 60.32,
    y: 72.97,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.09 95.32) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 60.06,
    y: 72.79,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.05 95.03) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 59.79,
    y: 72.61,
    width: 31.5,
    height: 0.32,
    transform: "translate(-27.02 94.73) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 59.53,
    y: 72.43,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.99 94.43) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 59.27,
    y: 72.25,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.96 94.13) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 59,
    y: 72.08,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.93, 93.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 58.74,
    y: 71.9,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.9, 93.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 58.47,
    y: 71.72,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.87 93.24) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 58.21,
    y: 71.54,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.84 92.94) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 57.94,
    y: 71.36,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.8, 92.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 57.68,
    y: 71.19,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.77 92.35) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 57.42,
    y: 71.01,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.74 92.05) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "81.58 57.84 63.97 83.96 64.23 84.14 81.84 58.02 81.58 57.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 56.89,
    y: 70.65,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.68 91.45) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 56.62,
    y: 70.47,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.65 91.16) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 56.36,
    y: 70.3,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.62 90.86) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 56.1,
    y: 70.12,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.59 90.56) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 55.83,
    y: 69.94,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.56, 90.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 55.57,
    y: 69.76,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.52 89.97) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 55.3,
    y: 69.58,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.49 89.67) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 55.04,
    y: 69.4,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.46 89.37) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 54.77,
    y: 69.23,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.43 89.08) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 54.51,
    y: 69.05,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.4 88.78) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 54.25,
    y: 68.87,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.37, 88.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 53.98,
    y: 68.69,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.34 88.19) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 53.72,
    y: 68.51,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.31 87.89) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 53.46,
    y: 68.34,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.28 87.59) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 53.19,
    y: 68.16,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.24 87.29) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "77.35 54.99 59.74 81.11 60 81.29 77.61 55.17 77.35 54.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 52.66,
    y: 67.8,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.18, 86.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "76.82 54.63 59.21 80.75 59.48 80.93 77.08 54.81 76.82 54.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 52.13,
    y: 67.45,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -26.12, 86.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 51.87,
    y: 67.27,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.09 85.8) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 51.61,
    y: 67.09,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.06 85.51) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 51.34,
    y: 66.91,
    width: 31.5,
    height: 0.32,
    transform: "translate(-26.03 85.21) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 51.08,
    y: 66.73,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.99 84.91) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 50.81,
    y: 66.56,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.96, 84.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 50.55,
    y: 66.38,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.93 84.32) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "74.71 53.21 57.1 79.33 57.36 79.51 74.97 53.39 74.71 53.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 50.02,
    y: 66.02,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.87, 83.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 49.76,
    y: 65.84,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.84 83.42) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 49.49,
    y: 65.67,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.81 83.13) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 49.23,
    y: 65.49,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.78 82.83) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 48.97,
    y: 65.31,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.75 82.53) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 48.7,
    y: 65.13,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.71, 82.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 48.44,
    y: 64.95,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.68, 81.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 48.17,
    y: 64.78,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.65 81.64) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 47.91,
    y: 64.6,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.62, 81.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 47.64,
    y: 64.42,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.59 81.04) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 47.38,
    y: 64.24,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.56 80.75) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 47.12,
    y: 64.06,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.53, 80.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 46.85,
    y: 63.89,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.5, 80.15)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "71.01 50.72 53.4 76.84 53.67 77.02 71.28 50.9 71.01 50.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 46.32,
    y: 63.53,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.43, 79.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 46.06,
    y: 63.35,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.4 79.26) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 45.8,
    y: 63.17,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.37 78.96) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "69.95 50.01 52.35 76.13 52.61 76.3 70.22 50.18 69.95 50.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 45.27,
    y: 62.82,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.31 78.37) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 45,
    y: 62.64,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.28 78.07) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 44.74,
    y: 62.46,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.25 77.77) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 44.48,
    y: 62.28,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.22 77.48) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 44.21,
    y: 62.1,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.18, 77.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 43.95,
    y: 61.93,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.15 76.88) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "68.11 48.76 50.5 74.88 50.76 75.06 68.37 48.94 68.11 48.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 43.42,
    y: 61.57,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -25.09, 76.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 43.16,
    y: 61.39,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25.06 75.99) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "67.31 48.23 49.7 74.34 49.97 74.52 67.58 48.4 67.31 48.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 42.63,
    y: 61.04,
    width: 31.5,
    height: 0.32,
    transform: "translate(-25 75.39) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 42.36,
    y: 60.86,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.97 75.1) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 42.1,
    y: 60.68,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.94, 74.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "66.26 47.51 48.65 73.63 48.91 73.81 66.52 47.69 66.26 47.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 41.57,
    y: 60.32,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.87 74.2) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 41.31,
    y: 60.15,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.84, 73.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 41.04,
    y: 59.97,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.81 73.6) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 40.78,
    y: 59.79,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.78 73.31) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 40.51,
    y: 59.61,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.75 73.01) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 40.25,
    y: 59.43,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.72 72.71) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 39.99,
    y: 59.26,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.69 72.42) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 39.72,
    y: 59.08,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.65 72.12) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 39.46,
    y: 58.9,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.62, 71.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 39.19,
    y: 58.72,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.59, 71.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 38.93,
    y: 58.54,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.56, 71.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 38.67,
    y: 58.37,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.53 70.93) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 38.4,
    y: 58.19,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.5 70.63) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "62.56 45.02 44.95 71.14 45.22 71.32 62.82 45.2 62.56 45.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 37.87,
    y: 57.83,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.44 70.04) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 37.61,
    y: 57.65,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.41, 69.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 37.35,
    y: 57.48,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.37 69.44) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 37.08,
    y: 57.3,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.34, 69.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 36.82,
    y: 57.12,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.31 68.85) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "60.98 43.95 43.37 70.07 43.63 70.25 61.24 44.13 60.98 43.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 36.29,
    y: 56.76,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.25 68.25) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "60.45 43.6 42.84 69.72 43.1 69.89 60.71 43.77 60.45 43.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 35.76,
    y: 56.41,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.19 67.66) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 35.5,
    y: 56.23,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.16, 67.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 35.23,
    y: 56.05,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.13, 67.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 34.97,
    y: 55.87,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.09 66.76) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 34.7,
    y: 55.7,
    width: 31.5,
    height: 0.32,
    transform: "translate(-24.06 66.47) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 34.44,
    y: 55.52,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24.03, 66.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 34.18,
    y: 55.34,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -24, 65.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 33.91,
    y: 55.16,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.97 65.58) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 33.65,
    y: 54.98,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.94 65.28) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 33.38,
    y: 54.8,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.91, 64.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 33.12,
    y: 54.63,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.88 64.68) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 32.86,
    y: 54.45,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.84 64.38) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 32.59,
    y: 54.27,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.81 64.09) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 32.33,
    y: 54.09,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.78, 63.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 32.06,
    y: 53.92,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.75 63.49) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 31.8,
    y: 53.74,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.72, 63.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 31.54,
    y: 53.56,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.69 62.9) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "55.69 40.39 38.09 66.51 38.35 66.69 55.96 40.57 55.69 40.39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 31.01,
    y: 53.2,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.63 62.3) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 30.74,
    y: 53.02,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.59 62.01) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 30.48,
    y: 52.85,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.56, 61.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 30.22,
    y: 52.67,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.53, 61.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 29.95,
    y: 52.49,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.5 61.11) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 29.69,
    y: 52.31,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.47 60.81) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 29.42,
    y: 52.13,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.44, 60.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 29.16,
    y: 51.96,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.41 60.22) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 28.89,
    y: 51.78,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.38, 59.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 28.63,
    y: 51.6,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.35, 59.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 28.37,
    y: 51.42,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.31, 59.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 28.1,
    y: 51.24,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.28, 59.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 27.84,
    y: 51.07,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23.25 58.73) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 27.57,
    y: 50.89,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.22, 58.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 27.31,
    y: 50.71,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.19, 58.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "51.47 37.54 33.86 63.66 34.12 63.84 51.73 37.72 51.47 37.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 26.78,
    y: 50.35,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.13, 57.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 26.52,
    y: 50.18,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.1, 57.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 26.25,
    y: 50,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -23.07, 56.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "50.41 36.83 32.8 62.95 33.07 63.13 50.68 37.01 50.41 36.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 25.73,
    y: 49.64,
    width: 31.5,
    height: 0.32,
    transform: "translate(-23 56.35) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 25.46,
    y: 49.46,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.97, 56.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 25.2,
    y: 49.29,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.94 55.76) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 24.93,
    y: 49.11,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.91 55.46) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 24.67,
    y: 48.93,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.88, 55.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 24.41,
    y: 48.75,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.85 54.86) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "48.56 35.58 30.95 61.7 31.22 61.88 48.83 35.76 48.56 35.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 23.88,
    y: 48.4,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.78 54.27) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 23.61,
    y: 48.22,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.75, 53.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 23.35,
    y: 48.04,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.72 53.67) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 23.08,
    y: 47.86,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.69 53.38) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 22.82,
    y: 47.68,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.66 53.08) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 22.56,
    y: 47.51,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.63, 52.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "46.71 34.34 29.11 60.46 29.37 60.63 46.98 34.52 46.71 34.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 22.03,
    y: 47.15,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.57 52.19) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 21.76,
    y: 46.97,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.54, 51.89)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "45.92 33.8 28.31 59.92 28.58 60.1 46.19 33.98 45.92 33.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 21.24,
    y: 46.62,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.47 51.3) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 20.97,
    y: 46.44,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.44 51) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 20.71,
    y: 46.26,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.41, 50.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 20.44,
    y: 46.08,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.38 50.4) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 20.18,
    y: 45.9,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.35 50.1) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 19.92,
    y: 45.73,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.32 49.81) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 19.65,
    y: 45.55,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.29 49.51) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "43.81 32.38 26.2 58.5 26.46 58.68 44.07 32.56 43.81 32.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 19.12,
    y: 45.19,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.22, 48.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 18.86,
    y: 45.01,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -22.19, 48.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 18.6,
    y: 44.83,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.16 48.32) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 18.33,
    y: 44.66,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.13 48.02) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 18.07,
    y: 44.48,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.1 47.73) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 17.8,
    y: 44.3,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.07 47.43) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "41.96 31.13 24.35 57.25 24.62 57.43 42.23 31.31 41.96 31.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 17.27,
    y: 43.94,
    width: 31.5,
    height: 0.32,
    transform: "translate(-22.01 46.83) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 17.01,
    y: 43.77,
    width: 31.5,
    height: 0.32,
    transform: "translate(-21.97 46.53) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "41.17 30.6 23.56 56.72 23.82 56.9 41.43 30.78 41.17 30.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 16.48,
    y: 43.41,
    width: 31.5,
    height: 0.32,
    transform: "translate(-21.91 45.94) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M23.3,56.54,40.9,30.42Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M43.86,25a4.43,4.43,0,0,1,1.56,1.86c3.35,5.05-6.83,36.66,5.54,54.85C63.6,100.33,53.84,96,53.84,96S31,103.83,43.92,35.72A14.67,14.67,0,0,0,44.3,32a4.43,4.43,0,1,1-.44-7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M73.44,30.59S58.65,14.78,86.25,15.34A47.61,47.61,0,0,1,105,19.84s18.74-.79,8.8,9.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M113.07,32.37s-23.5-1.19-39.24,1L73,30.22a270.2,270.2,0,0,1,40.43-1.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.12,70.08l28.37,5.35s5.62.54,5.62,7.24v25.71L34.51,119.9S59.63,82.4,67.46,75.7c.88-.75,4.92-1.64,9.88-2.48C87,71.57,100.12,70.08,100.12,70.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M93.92,32.06,74.18,33.63l.52,2.19L72.21,49.58l2.71.71-.38,3.13,2.3,1.47-.19,1.78s2.56,1.06,1.07,2.57S74.92,63.63,82,64c4.32.25,6.52,2.26,2.9,8.44,0-.57,3,4,7.66,4.3,7.18.41,17.14-3.21,17.14-3.21S94.26,37.8,93.92,32.06Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.19,36.14a2.3,2.3,0,0,0,1.23,2.92,12.87,12.87,0,0,0,2.76-.84c1.62-.66,5.16-.23,5.65.35s-1-3.29-6.62-1.61C74.73,38,75.19,36.14,75.19,36.14Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.15,40.55a6,6,0,0,0,3.26-.08c1.62-.55,3.85-.43,4.92.57a9,9,0,0,0-4.29.28s.55,2-.66,2.2-1.3-2-1.3-2A3.17,3.17,0,0,1,76.15,40.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M90.37,32s-3,3.93-1.75,5.75c3.88,5.88,2.69,13.83.88,22.74,0,0-6.22,14.21,26.3,8.63,0,0-4.64-3.61-2.93-14.37.91-5.72,3.89-23-1-22.25Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M115.93,72.35l-38.57,43,56.75-7V78.78a11.62,11.62,0,0,0-5.62-3.35C125.24,74.76,115.93,72.35,115.93,72.35Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.93 72.35 77.36 115.35 84.23 114.55 120.58 73.36 115.93 72.35"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.67,75.57s4.44.8,4.44,3.21l-26.83,32.75-7.75,1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M86.23,69.41,80,72.49s5.32,7.9,15.07,7.36,18-7.72,18-7.72l-4.83-1A37.23,37.23,0,0,1,94.5,74.5C87.41,74.63,86.23,69.41,86.23,69.41Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "134.11 78.78 107.28 111.53 108.25 111.47 134.25 79.85 134.11 78.78"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "99.53 112.53 129.67 75.57 128.49 75.44 97.75 112.67 99.53 112.53"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "115.4 71.85 116.76 76.78 108.6 79.66 107.39 87.2 99.68 89.39 99.08 96.65 91.22 98.7 89.7 106.93 83.21 107.75 115.4 71.85"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.19,30.43l.77,3.2s21.93-2,39.48-1c.94.05-.23-.26-.23-.26s-20.8-1.2-38.53.21C74.68,32.57,73.94,32.4,73.19,30.43Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M113.8,29.17a20.35,20.35,0,0,0,2.35,11.74l-2.11-1-.88,1.41s-3-4.62-1.66-12.46Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M86.23,69.41S71.29,72.69,67.46,75.7s-32.95,44.2-32.95,44.2L76.37,89.71s5-2.25,5.75-6.25S86.23,69.41,86.23,69.41Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M75.71,84A2.26,2.26,0,1,0,78,81.63,2.33,2.33,0,0,0,75.71,84Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M86.23,69.41,83.54,84.29s-.33,2.34-7,7-42,28.61-42,28.61L76.37,89.71s4.17-3.08,5.17-5.42S86.23,69.41,86.23,69.41Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "119.87 72.96 121.21 73.29 84.23 114.55 82.37 115.13 119.87 72.96"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M73.19,30.43s-3.69-4-3.69-8.72c0,0,11.25,1.25,13.25,6.88C82.75,28.59,76.27,29.27,73.19,30.43Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M92.25,28s7-9.25,20.62-5.37c0,0,3.25,2.15-1.37,6.26A95.48,95.48,0,0,0,92.25,28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,51.29s3.83-.5,4.5.92,1.58,4.5,2.83,3.58.33-1.66.08-1.66,2.25.33,0,2.5-4.25-2.75-4.41-3.5-3.25,0-3.25,0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.37,58.13S79.54,60,79,60a3.1,3.1,0,0,0-2.17,2.5S75.21,60.13,78.37,58.13Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M91.05,32.66c-.38,1.82-3.3,2.05,1,8.47,3.27,4.89.31,7.39-.83,11.33-2.84,9.75-1.17,15,8,17.67,0,0-14.75.83-10.42-13S88.71,43,87.71,39.54c-.64-2.22.33-5.07,1.66-6.83Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M96.37,33.09S94.5,36.46,99,43.21c5.24,7.86-3.75,12.5,1.37,20.13s13,5.85,15.43,5.74c0,0-11.3,1.38-14.43-6.12s3-13.87-1.12-20.62S96.37,34.21,96.37,33.09Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.54,26.39A2.1,2.1,0,0,1,86,27l.22-.23a2.12,2.12,0,1,1,1.92,0l.24.23a2.07,2.07,0,0,1,1.45-.58A2.11,2.11,0,1,1,87.7,28.5s0,0,0,0c-.27.25-.57,1,.07,3.47H86.57c.65-2.44.34-3.22.08-3.47v0a2.11,2.11,0,1,1-2.11-2.11Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-190",
    x1: 124.55,
    y1: 74.79,
    x2: 90.86,
    y2: 113.06
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M122.69,75.19a.91.91,0,0,1,.3.59h.14a.87.87,0,0,1,.16-.91.9.9,0,0,1,1.34,1.19.87.87,0,0,1-.88.27v.14a.89.89,0,0,1,.63.22.9.9,0,0,1,.09,1.26.9.9,0,0,1-1.35-1.19h0c-.15,0-.47.16-.94,1.11l-.39-.34c.89-.59,1-.92,1-1.07h0a.89.89,0,0,1-1.26.07.89.89,0,1,1,1.17-1.33Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M119.58,78.73a.89.89,0,0,1,.3.59H120a.87.87,0,0,1,.15-.91.89.89,0,0,1,1.26-.07.9.9,0,0,1,.09,1.26.86.86,0,0,1-.89.26V80a.94.94,0,0,1,.63.23.89.89,0,1,1-1.18,1.33.9.9,0,0,1-.09-1.26h0c-.16,0-.47.16-.94,1.11l-.39-.34c.89-.59,1-.92,1-1.07h0a.9.9,0,1,1-.09-1.26Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M116.46,82.27a1,1,0,0,1,.31.59h.13a.87.87,0,0,1,.16-.91.9.9,0,1,1,.46,1.45v.14a.91.91,0,0,1,.62.22.89.89,0,1,1-1.26.08v0c-.15,0-.46.17-.94,1.12l-.38-.34c.88-.59,1-.92,1-1.08v0a.89.89,0,0,1-1.26.07.9.9,0,0,1-.09-1.26A.89.89,0,0,1,116.46,82.27Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M113.35,85.81a.87.87,0,0,1,.3.59l.14,0a.88.88,0,0,1,1.41-1,.89.89,0,0,1-.8,1.53v.14a.89.89,0,0,1,.63.22.9.9,0,0,1,.09,1.26.9.9,0,0,1-1.35-1.19h0c-.15,0-.47.16-.94,1.12l-.39-.35c.89-.58,1-.92,1-1.07v0a.9.9,0,0,1-1.35-1.19A.89.89,0,0,1,113.35,85.81Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M110.24,89.34a.91.91,0,0,1,.3.59h.13a.87.87,0,0,1,.16-.91.89.89,0,0,1,1.26-.07.89.89,0,0,1-.8,1.53v.13a.92.92,0,0,1,.62.23.89.89,0,1,1-1.17,1.33.9.9,0,0,1-.09-1.26h0c-.15,0-.46.16-.93,1.11l-.39-.34c.88-.59,1-.92,1-1.07h0a.9.9,0,0,1-1.27.07.89.89,0,1,1,1.18-1.33Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M107.12,92.88a.89.89,0,0,1,.3.59h.14a.87.87,0,0,1,.16-.91.89.89,0,0,1,1.26-.07.88.88,0,0,1-.81,1.52v.14a.91.91,0,0,1,.72,1.49.91.91,0,0,1-1.26.07.89.89,0,0,1-.09-1.26v0c-.15,0-.47.17-.94,1.12l-.39-.34c.89-.59,1-.92,1-1.07h0a.89.89,0,0,1-1.26.07.9.9,0,0,1-.09-1.26A.89.89,0,0,1,107.12,92.88Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M104,96.42a.89.89,0,0,1,.3.59h.14a.88.88,0,0,1,1.41-1,.9.9,0,0,1,.09,1.26.89.89,0,0,1-.89.27v.14a.93.93,0,0,1,.63.22.89.89,0,1,1-1.27.07h0c-.16,0-.47.17-.94,1.12l-.39-.34c.89-.59,1-.92,1-1.08v0a.9.9,0,1,1-.09-1.26Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M100.89,100a.93.93,0,0,1,.31.59l.13,0a.87.87,0,0,1,.16-.91.89.89,0,0,1,1.26-.07.89.89,0,0,1-.8,1.53v.14a.86.86,0,0,1,.62.22.9.9,0,0,1,.09,1.26.89.89,0,0,1-1.26.07.9.9,0,0,1-.09-1.26h0c-.15,0-.47.16-.94,1.11l-.38-.34c.88-.59,1-.92,1-1.07v0A.9.9,0,0,1,99.63,100,.89.89,0,0,1,100.89,100Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M97.78,103.49a.89.89,0,0,1,.3.59h.14a.88.88,0,0,1,1.41-1,.89.89,0,0,1-.8,1.53v.13a.94.94,0,0,1,.63.23.9.9,0,0,1,.09,1.26.9.9,0,0,1-1.35-1.19h0c-.15,0-.47.16-.94,1.11l-.39-.34c.89-.59,1-.92,1-1.07h0a.89.89,0,0,1-1.26.07.89.89,0,1,1,1.17-1.33Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M94.67,107a.94.94,0,0,1,.3.59h.13a.87.87,0,0,1,.16-.91.9.9,0,1,1,.46,1.45v.14a.91.91,0,0,1,.71,1.49.9.9,0,0,1-1.35-1.19v0c-.15,0-.46.17-.93,1.12l-.39-.34c.88-.59,1-.92,1-1.07h0a.89.89,0,0,1-1.26.07A.89.89,0,1,1,94.67,107Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M91.55,110.57a.87.87,0,0,1,.3.59H92a.89.89,0,0,1,1.42-1,.89.89,0,0,1,.08,1.26.88.88,0,0,1-.89.27v.14a.87.87,0,0,1,.63.22.9.9,0,0,1,.09,1.26A.9.9,0,0,1,92,112.12h0c-.15,0-.47.16-.94,1.12l-.39-.35c.89-.58,1-.91,1-1.07v0a.9.9,0,0,1-1.35-1.19A.89.89,0,0,1,91.55,110.57Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-184",
    x1: 132.41,
    y1: 76.51,
    x2: 103.7,
    y2: 110.86
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M130.7,76.83a1,1,0,0,1,.33.55h.12a.78.78,0,0,1,.08-.83.89.89,0,0,1,1.36,1.13.75.75,0,0,1-.82.22l0,.13a1,1,0,0,1,.61.23.84.84,0,0,1,.18,1.17.83.83,0,0,1-1.18,0,.82.82,0,0,1-.18-1.16h0c-.14,0-.43.13-.8,1l-.39-.33c.79-.52.87-.82.85-1h0a.83.83,0,0,1-1.18,0,.82.82,0,0,1-.18-1.16A.83.83,0,0,1,130.7,76.83Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M128,80a.91.91,0,0,1,.33.56h.13a.77.77,0,0,1,.07-.84.9.9,0,0,1,1.37,1.14.78.78,0,0,1-.82.22l0,.13a.93.93,0,0,1,.6.22.79.79,0,1,1-1.18,0h0c-.15,0-.43.14-.8,1l-.39-.32c.78-.52.87-.82.84-1h0a.84.84,0,0,1-1.18,0,.85.85,0,0,1-.18-1.17A.84.84,0,0,1,128,80Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M125.39,83.18a1,1,0,0,1,.33.55h.13a.77.77,0,0,1,.07-.84.83.83,0,0,1,1.18,0,.82.82,0,0,1,.18,1.16.76.76,0,0,1-.81.23l0,.12a1,1,0,0,1,.6.23.78.78,0,1,1-1.18,0h0c-.14,0-.43.13-.79,1l-.4-.33c.79-.51.88-.82.85-1h0a.83.83,0,0,1-1.18,0,.82.82,0,0,1-.18-1.16A.83.83,0,0,1,125.39,83.18Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M122.74,86.35a.92.92,0,0,1,.32.56h.13a.77.77,0,0,1,.08-.84.84.84,0,0,1,1.18,0,.85.85,0,0,1,.18,1.17.77.77,0,0,1-.82.22l0,.13a.91.91,0,0,1,.61.23.78.78,0,1,1-1.18,0h0c-.15,0-.43.14-.8,1l-.39-.33c.79-.52.87-.82.85-1h0a.89.89,0,1,1-.18-1.17Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M120.08,89.53a1,1,0,0,1,.33.55h.13a.77.77,0,0,1,.07-.84A.89.89,0,0,1,122,90.38a.78.78,0,0,1-.81.22l0,.12a1,1,0,0,1,.6.23.78.78,0,1,1-1,1.2A.85.85,0,0,1,120.6,91h0c-.14,0-.42.13-.79,1l-.39-.33c.78-.51.87-.82.84-1h0a.83.83,0,0,1-1.18,0,.78.78,0,1,1,1-1.19Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M117.43,92.7a1,1,0,0,1,.33.56h.12a.79.79,0,0,1,.08-.84.89.89,0,0,1,1.36,1.14.77.77,0,0,1-.82.22l0,.13a.91.91,0,0,1,.6.23.83.83,0,0,1,.18,1.16A.89.89,0,0,1,118,94.15h0c-.14,0-.43.14-.8,1l-.39-.33c.79-.52.87-.82.85-1h0a.89.89,0,1,1-.18-1.17Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M114.77,95.88a.87.87,0,0,1,.33.55h.13a.77.77,0,0,1,.08-.84.84.84,0,0,1,1.18,0,.85.85,0,0,1,.18,1.17.8.8,0,0,1-.82.22l0,.13a1,1,0,0,1,.61.22.85.85,0,0,1,.18,1.17.89.89,0,0,1-1.36-1.14h0c-.15,0-.43.14-.8,1l-.39-.33c.79-.51.87-.82.84-1v0a.9.9,0,0,1-1.37-1.14A.84.84,0,0,1,114.77,95.88Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M112.12,99.05a1,1,0,0,1,.33.56h.13a.78.78,0,0,1,.07-.84.83.83,0,0,1,1.18,0A.82.82,0,0,1,114,99.9a.76.76,0,0,1-.81.22l0,.13a1,1,0,0,1,.6.23.82.82,0,0,1,.18,1.16.83.83,0,0,1-1.18,0,.84.84,0,0,1-.18-1.16v0c-.14,0-.42.14-.79,1l-.39-.33c.78-.52.87-.82.84-1h0a.84.84,0,0,1-1.18,0,.85.85,0,0,1-.18-1.17A.84.84,0,0,1,112.12,99.05Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M109.47,102.23a1,1,0,0,1,.33.55h.12a.79.79,0,0,1,.08-.84.89.89,0,0,1,1.36,1.14.79.79,0,0,1-.82.22l0,.13a1,1,0,0,1,.61.22.79.79,0,1,1-1,1.2.84.84,0,0,1-.18-1.17h0c-.14,0-.43.14-.8,1l-.39-.32c.79-.52.87-.82.85-1v0a.83.83,0,0,1-1.18,0,.82.82,0,0,1-.18-1.16A.84.84,0,0,1,109.47,102.23Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M106.81,105.41a.92.92,0,0,1,.33.55h.13a.74.74,0,0,1,.08-.83.83.83,0,0,1,1.18,0,.84.84,0,0,1,.18,1.16.76.76,0,0,1-.82.22l0,.13a.94.94,0,0,1,.6.23.78.78,0,1,1-1.18,0h0c-.15,0-.43.13-.8,1l-.39-.33c.79-.52.87-.82.84-1h0a.9.9,0,0,1-1.37-1.14A.83.83,0,0,1,106.81,105.41Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M104.16,108.58a1,1,0,0,1,.33.55h.13a.77.77,0,0,1,.07-.84.89.89,0,0,1,1.36,1.14.78.78,0,0,1-.81.22l0,.13a1,1,0,0,1,.6.22.79.79,0,1,1-1,1.2.85.85,0,0,1-.18-1.17h0c-.14,0-.42.14-.79,1l-.4-.32c.79-.52.88-.82.85-1h0a.84.84,0,0,1-1.18,0,.85.85,0,0,1-.18-1.17A.84.84,0,0,1,104.16,108.58Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.04 113.04 57.71 53.46 56.21 52.96 33.29 112.54 35.04 113.04"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M44.38,105.07l9.2-11.49L50.06,91.4A15.37,15.37,0,0,1,46.29,87c-.35-.68-2.32.07-.61,3l1.39,2.84-6.45-5.31s-3.54-3.2-3.7-1.72c-.09.93,1.3,2.86,1.89,3.25s4.88,5.45,4.88,5.45l-5.24-3.94s-3.88-3.18-4.21-2.66c-1.26,2,1.3,3.77,2,4.21s5.79,5,5.79,5l-6.88-3.87s-2.64-1.89-2.82-1.17c-.46,1.76,1.39,3,1.77,3.21.69.4,5.81,3.8,5.81,3.8l-1.8-.24s-5.3-1.92-5.34-1.46c-.19,2.3,9.32,6.28,9.32,6.28A23.13,23.13,0,0,0,44.38,105.07Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-201",
    points: "83.37 106.66 53.96 90.81 33.38 119.9 77.22 115.24 83.2 107.47"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.96 90.81 57.62 92.96 38.75 119.09 33.38 119.9 53.96 90.81"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M54.28,92.64a.83.83,0,0,1,.31.46l.11,0a.65.65,0,0,1,0-.71.73.73,0,0,1,1-.1.72.72,0,0,1,.22,1,.64.64,0,0,1-.68.23l0,.11a.83.83,0,0,1,.53.16.71.71,0,0,1,.22,1,.76.76,0,0,1-1.22-.89h0c-.12,0-.35.14-.62.9l-.35-.26c.64-.48.7-.75.67-.87v0a.76.76,0,1,1-.22-1Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M52.2,95.5a.81.81,0,0,1,.31.45h.11a.65.65,0,0,1,0-.72.76.76,0,0,1,1.22.89.67.67,0,0,1-.68.24l0,.1a.81.81,0,0,1,.53.16A.67.67,0,1,1,53,97.69a.72.72,0,0,1-.22-1h0c-.12,0-.35.14-.62.9l-.35-.25c.64-.49.7-.75.67-.87h0a.76.76,0,1,1-.22-1Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M50.12,98.35a.81.81,0,0,1,.31.45h.11a.65.65,0,0,1,0-.71.76.76,0,0,1,1.22.89.66.66,0,0,1-.68.23l0,.11a.81.81,0,0,1,.53.16.7.7,0,0,1,.22,1,.76.76,0,0,1-1.22-.89h0c-.12,0-.36.14-.62.9l-.36-.26c.65-.48.7-.75.67-.87v0a.76.76,0,1,1-.22-1Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M48,101.21a.82.82,0,0,1,.32.45h.1a.67.67,0,0,1,0-.72.76.76,0,0,1,1.22.89.64.64,0,0,1-.68.23l0,.11a.81.81,0,0,1,.53.16.67.67,0,1,1-1,.09h0c-.12,0-.36.14-.62.9l-.35-.26c.64-.48.69-.74.66-.86h0a.71.71,0,0,1-1,.09.73.73,0,0,1-.22-1A.71.71,0,0,1,48,101.21Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M46,104.06a.78.78,0,0,1,.32.45h.1a.67.67,0,0,1,0-.72.72.72,0,0,1,1-.09.71.71,0,0,1,.22,1,.67.67,0,0,1-.68.24l0,.11a.83.83,0,0,1,.53.15.67.67,0,1,1-.79,1.08.74.74,0,0,1-.22-1h0c-.12,0-.36.14-.62.89l-.35-.25c.64-.49.69-.75.66-.87h0a.77.77,0,1,1-.23-1Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M43.89,106.91a.83.83,0,0,1,.31.46l.11,0a.65.65,0,0,1,0-.71.77.77,0,0,1,1.23.89.66.66,0,0,1-.69.23l0,.11a.84.84,0,0,1,.53.16.72.72,0,0,1,.22,1,.77.77,0,0,1-1.23-.89h0c-.12,0-.35.14-.62.9l-.35-.26c.64-.48.69-.74.67-.86h0a.74.74,0,0,1-1,.09.67.67,0,1,1,.79-1.08Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M41.81,109.77a.81.81,0,0,1,.31.45h.11a.65.65,0,0,1,0-.72.7.7,0,0,1,1-.09.73.73,0,0,1,.22,1,.67.67,0,0,1-.68.24l0,.1a.83.83,0,0,1,.53.16.71.71,0,0,1,.22,1,.76.76,0,0,1-1.22-.89h0c-.12,0-.35.13-.62.89l-.35-.25c.64-.49.7-.75.67-.87h0a.76.76,0,1,1-.22-1Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M39.73,112.62a.8.8,0,0,1,.31.46l.11,0a.65.65,0,0,1,0-.72.76.76,0,0,1,1.22.9.64.64,0,0,1-.68.23l0,.11a.81.81,0,0,1,.53.16.67.67,0,1,1-1,.09h0c-.12,0-.35.14-.62.9l-.35-.26c.64-.48.7-.75.67-.86h0a.72.72,0,0,1-1,.09.67.67,0,1,1,.78-1.08Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M37.65,115.48a.81.81,0,0,1,.31.45h.11a.67.67,0,0,1,0-.72.76.76,0,0,1,1.22.89.67.67,0,0,1-.68.24l0,.1a.81.81,0,0,1,.53.16.67.67,0,1,1-.78,1.08.72.72,0,0,1-.22-1h0c-.13,0-.36.14-.62.9l-.36-.25c.65-.49.7-.75.67-.87h0a.76.76,0,1,1-.22-1Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "36.21 105.13 31.04 106.29 27.71 113.96 33.29 112.54 36.21 105.13"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "37.87 105.63 40.21 109.96 36.65 115.57 35.04 113.04 37.87 105.63"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M59.21,47s-6,3-8.5,8.33l6-1.5,3,4.17S61.54,53.46,59.21,47Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.81,166.29l17.61-26.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 73,
    y: 153.16,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -87.99, 141.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 73.26,
    y: 153.34,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.02 141.5) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "80.6 166.82 98.21 140.71 97.95 140.53 80.34 166.65 80.6 166.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 73.79,
    y: 153.69,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.08, 142.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 74.05,
    y: 153.87,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.11, 142.39)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "81.39 167.36 99 141.24 98.74 141.06 81.13 167.18 81.39 167.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 74.58,
    y: 154.23,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.18 142.99) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 74.85,
    y: 154.41,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.21, 143.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 75.11,
    y: 154.58,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.24 143.57) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 75.37,
    y: 154.76,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.27 143.88) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 75.64,
    y: 154.94,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.3, 144.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 75.9,
    y: 155.12,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.33, 144.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 76.17,
    y: 155.3,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.36 144.77) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 76.43,
    y: 155.47,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.4 145.07) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 76.69,
    y: 155.65,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.43, 145.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 76.96,
    y: 155.83,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.46, 145.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 77.22,
    y: 156.01,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.49 145.96) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 77.49,
    y: 156.19,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.52, 146.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 77.75,
    y: 156.37,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.55, 146.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 78.01,
    y: 156.54,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.58 146.85) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 78.28,
    y: 156.72,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.61 147.15) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 78.54,
    y: 156.9,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.64, 147.45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "85.88 170.38 103.49 144.27 103.23 144.09 85.62 170.21 85.88 170.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 79.07,
    y: 157.25,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.71 148.04) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 79.34,
    y: 157.43,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.74 148.34) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 79.6,
    y: 157.61,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.77, 148.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 79.86,
    y: 157.79,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.8 148.93) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 80.13,
    y: 157.97,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.83 149.23) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 80.39,
    y: 158.15,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.86 149.53) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 80.65,
    y: 158.32,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.89, 149.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 80.92,
    y: 158.5,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.93 150.12) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 81.18,
    y: 158.68,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -88.96, 150.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 81.45,
    y: 158.86,
    width: 31.5,
    height: 0.32,
    transform: "translate(-88.99 150.72) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 81.71,
    y: 159.04,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.02, 151.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 81.98,
    y: 159.21,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.05 151.32) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 82.24,
    y: 159.39,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.08 151.61) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 82.5,
    y: 159.57,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.11 151.9) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 82.77,
    y: 159.75,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.14 152.2) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "90.11 173.23 107.72 147.12 107.45 146.94 89.85 173.06 90.11 173.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 83.3,
    y: 160.1,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.21 152.8) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "90.64 173.59 108.25 147.47 107.98 147.29 90.37 173.41 90.64 173.59"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 83.82,
    y: 160.46,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.27, 153.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 84.09,
    y: 160.64,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.3 153.69) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 84.35,
    y: 160.82,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.33, 153.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 84.62,
    y: 160.99,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.36 154.28) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 84.88,
    y: 161.17,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.39 154.59) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 85.15,
    y: 161.35,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.42 154.89) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 85.41,
    y: 161.53,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.46 155.18) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "92.75 175.01 110.36 148.9 110.09 148.72 92.49 174.84 92.75 175.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 85.94,
    y: 161.88,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.52 155.77) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 86.2,
    y: 162.06,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.55, 156.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 86.47,
    y: 162.24,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.58, 156.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 86.73,
    y: 162.42,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.61, 156.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 86.99,
    y: 162.6,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.64 156.97) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 87.26,
    y: 162.77,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.67 157.26) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 87.52,
    y: 162.95,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.7 157.56) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 87.79,
    y: 163.13,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.74 157.86) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 88.05,
    y: 163.31,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.77 158.15) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 88.31,
    y: 163.49,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.8 158.45) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 88.58,
    y: 163.66,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.83 158.75) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 88.84,
    y: 163.84,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.86 159.05) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 89.11,
    y: 164.02,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.89 159.34) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "96.45 177.51 114.06 151.39 113.79 151.21 96.18 177.33 96.45 177.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 89.63,
    y: 164.38,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -89.95, 159.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 89.9,
    y: 164.55,
    width: 31.5,
    height: 0.32,
    transform: "translate(-89.98 160.24) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 90.16,
    y: 164.73,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.02 160.54) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "97.5 178.22 115.11 152.1 114.85 151.92 97.24 178.04 97.5 178.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 90.69,
    y: 165.09,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.08 161.13) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 90.95,
    y: 165.27,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.11, 161.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 91.22,
    y: 165.45,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.14 161.72) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 91.48,
    y: 165.62,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.17, 162.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 91.75,
    y: 165.8,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.2, 162.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 92.01,
    y: 165.98,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.23 162.62) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "99.35 179.47 116.96 153.35 116.7 153.17 99.09 179.29 99.35 179.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 92.54,
    y: 166.34,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.3, 163.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 92.8,
    y: 166.51,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.33, 163.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "100.15 180 117.75 153.88 117.49 153.7 99.88 179.82 100.15 180"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 93.33,
    y: 166.87,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.39, 164.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 93.6,
    y: 167.05,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.42 164.41) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 93.86,
    y: 167.23,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.45, 164.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "101.2 180.71 118.81 154.59 118.55 154.41 100.94 180.53 101.2 180.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 94.39,
    y: 167.58,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.51, 165.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 94.65,
    y: 167.76,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.55 165.6) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 94.92,
    y: 167.94,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.58 165.88) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 95.18,
    y: 168.12,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.61, 166.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 95.44,
    y: 168.29,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.64, 166.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 95.71,
    y: 168.47,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.67 166.78) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 95.97,
    y: 168.65,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.7 167.08) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 96.24,
    y: 168.83,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.73, 167.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 96.5,
    y: 169.01,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.76 167.68) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 96.76,
    y: 169.18,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.79 167.97) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 97.03,
    y: 169.36,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.83 168.27) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 97.29,
    y: 169.54,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.86, 168.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 97.56,
    y: 169.72,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.89, 168.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "104.9 183.2 122.51 157.09 122.24 156.91 104.64 183.03 104.9 183.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 98.09,
    y: 170.07,
    width: 31.5,
    height: 0.32,
    transform: "translate(-90.95 169.46) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 98.35,
    y: 170.25,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -90.98, 169.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 98.61,
    y: 170.43,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.01 170.05) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 98.88,
    y: 170.61,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.04 170.35) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 99.14,
    y: 170.79,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.08, 170.65)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "106.48 184.27 124.09 158.15 123.83 157.98 106.22 184.09 106.48 184.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 99.67,
    y: 171.14,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.14 171.24) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "107.01 184.63 124.62 158.51 124.36 158.33 106.75 184.45 107.01 184.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 100.2,
    y: 171.5,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.2, 171.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 100.46,
    y: 171.68,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.23, 172.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 100.73,
    y: 171.85,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.26 172.43) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 100.99,
    y: 172.03,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.29 172.74) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 101.25,
    y: 172.21,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.32, 173.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 101.52,
    y: 172.39,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.36 173.33) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 101.78,
    y: 172.57,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.39 173.62) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 102.05,
    y: 172.75,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.42 173.93) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 102.31,
    y: 172.92,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.45 174.22) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 102.57,
    y: 173.1,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.48, 174.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 102.84,
    y: 173.28,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.51 174.82) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 103.1,
    y: 173.46,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.54, 175.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 103.37,
    y: 173.64,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.57 175.4) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 103.63,
    y: 173.81,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.61 175.71) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 103.89,
    y: 173.99,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.64 176.01) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 104.16,
    y: 174.17,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.67 176.3) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 104.42,
    y: 174.35,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.7 176.6) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "111.77 187.83 129.37 161.72 129.11 161.54 111.5 187.66 111.77 187.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 104.95,
    y: 174.7,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.76, 177.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 105.22,
    y: 174.88,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.79 177.5) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 105.48,
    y: 175.06,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.82 177.79) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 105.74,
    y: 175.24,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.85 178.09) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 106.01,
    y: 175.42,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.89 178.39) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 106.27,
    y: 175.59,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.92, 178.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 106.54,
    y: 175.77,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -91.95, 178.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 106.8,
    y: 175.95,
    width: 31.5,
    height: 0.32,
    transform: "translate(-91.98 179.28) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 107.06,
    y: 176.13,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.01 179.57) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 107.33,
    y: 176.31,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.04 179.88) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 107.59,
    y: 176.48,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.07 180.17) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 107.86,
    y: 176.66,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.1 180.47) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 108.12,
    y: 176.84,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.14 180.76) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 108.38,
    y: 177.02,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.17, 181.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 108.65,
    y: 177.2,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.2 181.36) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "115.99 190.68 133.6 164.56 133.34 164.38 115.73 190.5 115.99 190.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 109.18,
    y: 177.55,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.26, 181.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 109.44,
    y: 177.73,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.29 182.25) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 109.71,
    y: 177.91,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.32 182.55) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "117.05 191.39 134.66 165.28 134.39 165.1 116.78 191.22 117.05 191.39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 110.23,
    y: 178.26,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.38 183.15) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 110.5,
    y: 178.44,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.42 183.45) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 110.76,
    y: 178.62,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.45 183.73) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 111.03,
    y: 178.8,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.48 184.04) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 111.29,
    y: 178.98,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.51, 184.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "118.63 192.46 136.24 166.34 135.98 166.16 118.37 192.28 118.63 192.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "118.9 192.64 136.5 166.52 136.24 166.34 118.63 192.46 118.9 192.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 112.08,
    y: 179.51,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.6, 185.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 112.35,
    y: 179.69,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.63, 185.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 112.61,
    y: 179.87,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.67, 185.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 112.87,
    y: 180.04,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.7 186.12) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 113.14,
    y: 180.22,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.73 186.42) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 113.4,
    y: 180.4,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.76 186.72) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "120.75 193.89 138.35 167.77 138.09 167.59 120.48 193.71 120.75 193.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 113.93,
    y: 180.76,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.82 187.31) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 114.2,
    y: 180.94,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.85, 187.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "121.54 194.42 139.15 168.3 138.88 168.12 121.27 194.24 121.54 194.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 114.72,
    y: 181.29,
    width: 31.5,
    height: 0.32,
    transform: "translate(-92.91 188.21) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 114.99,
    y: 181.47,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.95, 188.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 115.25,
    y: 181.65,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -92.98, 188.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 115.52,
    y: 181.83,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.01 189.09) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 115.78,
    y: 182,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -93.04, 189.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 116.04,
    y: 182.18,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.07 189.69) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 116.31,
    y: 182.36,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.1 189.98) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "123.65 195.84 141.26 169.73 140.99 169.55 123.39 195.67 123.65 195.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 116.84,
    y: 182.72,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.16 190.59) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 117.1,
    y: 182.89,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -93.19, 190.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 117.36,
    y: 183.07,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -93.23, 191.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 117.63,
    y: 183.25,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.26 191.48) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 117.89,
    y: 183.43,
    width: 31.5,
    height: 0.32,
    transform: "matrix(0.56, -0.83, 0.83, 0.56, -93.29, 191.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 118.16,
    y: 183.61,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.32 192.07) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "125.5 197.09 143.11 170.97 142.84 170.79 125.23 196.91 125.5 197.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 118.68,
    y: 183.96,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.38 192.67) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 118.95,
    y: 184.14,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.41 192.96) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "126.29 197.63 143.9 171.51 143.63 171.33 126.03 197.45 126.29 197.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 119.48,
    y: 184.5,
    width: 31.5,
    height: 0.32,
    transform: "translate(-93.48 193.56) rotate(-56.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M144.16,171.68,126.55,197.8Z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M123.6,203.2a4.39,4.39,0,0,1-1.56-1.87c-3.35-5.05,6.83-36.65-5.54-54.85-12.64-18.58-2.88-14.23-2.88-14.23s22.85-7.85,9.92,60.26a14.6,14.6,0,0,0-.38,3.69,4.43,4.43,0,1,1,.44,7Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M94,197.63s14.8,15.81-12.8,15.26a47.81,47.81,0,0,1-18.75-4.5s-18.74.78-8.81-9.5Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M54.39,195.85s23.49,1.19,39.24-1l.83,3.16A270.3,270.3,0,0,1,54,199.3Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.34,158.15,39,152.79s-5.62-.53-5.62-7.23V119.84L133,108.32s-25.12,37.51-32.95,44.2c-.88.75-4.92,1.64-9.88,2.49C80.47,156.66,67.34,158.15,67.34,158.15Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M73.54,196.17l19.74-1.57-.52-2.19,2.49-13.76-2.71-.72.38-3.12-2.3-1.48.19-1.77s-2.56-1.07-1.07-2.57,2.8-4.4-4.3-4.8c-4.32-.24-6.52-2.25-2.9-8.44,0,.58-3-4-7.66-4.3-7.18-.41-17.14,3.21-17.14,3.21S73.2,190.42,73.54,196.17Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.27,192.09A2.29,2.29,0,0,0,91,189.17a12.24,12.24,0,0,0-2.76.83c-1.62.67-5.16.23-5.65-.34s1,3.28,6.62,1.61C92.73,190.24,92.27,192.09,92.27,192.09Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.31,187.67a6.1,6.1,0,0,0-3.26.08c-1.62.56-3.85.44-4.92-.57a9.09,9.09,0,0,0,4.29-.27s-.55-2,.66-2.21,1.3,2,1.3,2A3.17,3.17,0,0,1,91.31,187.67Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.09,196.26s2.94-3.93,1.75-5.75c-3.88-5.87-2.69-13.83-.88-22.74,0,0,6.22-14.2-26.31-8.62,0,0,4.65,3.61,2.94,14.36-.91,5.73-3.89,23.05,1,22.25Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M51.53,155.87l38.57-43-56.75,7v29.6A11.62,11.62,0,0,0,39,152.79C42.22,153.46,51.53,155.87,51.53,155.87Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.53 155.87 90.1 112.88 83.23 113.68 46.88 154.87 51.53 155.87"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.79,152.66s-4.44-.81-4.44-3.22l26.82-32.75,7.76-1Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M81.23,158.82l6.21-3.08s-5.32-7.9-15.07-7.37-18,7.73-18,7.73l4.83,1A37,37,0,0,1,73,153.73C80.05,153.6,81.23,158.82,81.23,158.82Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "33.35 149.44 60.17 116.69 59.21 116.76 33.21 148.37 33.35 149.44"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "67.93 115.69 37.79 152.66 38.97 152.79 69.7 115.56 67.93 115.69"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "52.06 156.37 50.7 151.44 58.86 148.56 60.07 141.03 67.78 138.84 68.38 131.57 76.24 129.52 77.75 121.3 84.25 120.48 52.06 156.37"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.26,197.8l-.76-3.21s-21.93,2-39.48,1c-.94,0,.23.26.23.26s20.8,1.2,38.53-.21C92.78,195.65,93.52,195.82,94.26,197.8Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M53.65,199.05a20.27,20.27,0,0,0-2.34-11.73l2.1,1,.89-1.4s3,4.62,1.66,12.45Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M81.23,158.82s14.93-3.28,18.77-6.3S133,108.32,133,108.32L91.09,138.51s-5,2.25-5.75,6.25S81.23,158.82,81.23,158.82Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-210",
    cx: 89.5,
    cy: 144.18,
    rx: 2.25,
    ry: 2.42
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M81.23,158.82l2.69-14.89s.33-2.33,7-7,42-28.61,42-28.61L91.09,138.51s-4.17,3.09-5.17,5.42S81.23,158.82,81.23,158.82Z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "47.59 155.26 46.25 154.93 83.23 113.68 85.09 113.1 47.59 155.26"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M94.26,197.8s-29.79,2.29-40.61,1.25C53.65,199.05,75.07,202.33,94.26,197.8Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M94.26,197.8s3.7,4,3.7,8.71c0,0-11.25-1.25-13.25-6.87C84.71,199.64,91.19,199,94.26,197.8Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M75.21,200.26s-7,9.25-20.62,5.38c0,0-3.25-2.16,1.37-6.27A95.48,95.48,0,0,0,75.21,200.26Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.5,176.93s-3.83.5-4.5-.92-1.58-4.5-2.83-3.58-.33,1.67-.08,1.67-2.25-.34,0-2.5,4.25,2.75,4.41,3.5,3.25,0,3.25,0Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.09,170.1s-1.17-1.84-.67-1.84a3.08,3.08,0,0,0,2.17-2.5S92.25,168.1,89.09,170.1Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M76.41,195.56c.38-1.81,3.3-2.05-1-8.46-3.27-4.9-.31-7.4.83-11.34,2.84-9.75,1.17-15-8-17.66,0,0,14.75-.84,10.42,13s.08,14.08,1.08,17.58c.64,2.23-.34,5.08-1.66,6.83Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M71.09,195.14S73,191.76,68.46,185c-5.24-7.86,3.75-12.5-1.37-20.12s-13-5.86-15.44-5.74c0,0,11.31-1.39,14.44,6.11s-3,13.88,1.12,20.63S71.09,194,71.09,195.14Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.54,205.55A2.06,2.06,0,0,1,81.1,205l-.23.23a2.12,2.12,0,1,1-1.92,0l-.23-.23a2.15,2.15,0,0,1-1.45.58,2.12,2.12,0,1,1,2.11-2.12v0c.26-.25.57-1-.08-3.48h1.21c-.64,2.45-.34,3.23-.08,3.48v0a2.11,2.11,0,1,1,2.11,2.12Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-190",
    x1: 42.91,
    y1: 153.43,
    x2: 76.6,
    y2: 115.17
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M44.77,153a1,1,0,0,1-.31-.59h-.13a.87.87,0,0,1-.16.91.89.89,0,0,1-1.26.07.9.9,0,0,1-.09-1.26.91.91,0,0,1,.89-.26v-.14a.91.91,0,0,1-.62-.22.89.89,0,1,1,1.26-.08v0c.15,0,.47-.17.94-1.12l.39.34c-.89.59-1,.92-1,1.07h0a.89.89,0,0,1,1.26-.07A.9.9,0,0,1,46,153,.89.89,0,0,1,44.77,153Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M47.88,149.49a.87.87,0,0,1-.3-.59h-.14a.89.89,0,0,1-.15.92.9.9,0,0,1-1.26.07.89.89,0,0,1,.8-1.53v-.14a.89.89,0,0,1-.63-.22.89.89,0,1,1,1.27-.07h0c.15,0,.47-.16.94-1.12l.39.35c-.89.58-1,.92-1,1.07v0a.9.9,0,0,1,1.35,1.19A.89.89,0,0,1,47.88,149.49Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M51,146a.9.9,0,0,1-.31-.59h-.13a.87.87,0,0,1-.16.91.89.89,0,0,1-1.26.07.89.89,0,0,1,.8-1.53v-.13a.92.92,0,0,1-.62-.23.89.89,0,1,1,1.17-1.33.9.9,0,0,1,.09,1.26h0c.15,0,.46-.16.93-1.11l.39.34c-.88.59-1,.92-1,1.07h0a.9.9,0,0,1,1.35,1.18A.9.9,0,0,1,51,146Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M54.11,142.42a.89.89,0,0,1-.3-.59h-.14a.89.89,0,1,1-1.5-.28.86.86,0,0,1,.89-.26v-.14a.89.89,0,1,1,.54-1.56.88.88,0,0,1,.09,1.26h0c.15,0,.47-.16.94-1.11l.39.34c-.89.59-1,.92-1,1.07h0a.89.89,0,0,1,1.26-.07.9.9,0,0,1,.09,1.26A.89.89,0,0,1,54.11,142.42Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M57.22,138.88a.89.89,0,0,1-.3-.59h-.13a.89.89,0,0,1-1.42,1,.89.89,0,0,1,.8-1.53v-.14a.89.89,0,0,1-.62-.22.89.89,0,1,1,1.17-1.33.9.9,0,0,1,.09,1.26h0c.15,0,.46-.17.93-1.12l.39.34c-.88.59-1,.92-1,1.07h0a.9.9,0,1,1,.09,1.26Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M60.34,135.34a.87.87,0,0,1-.3-.58H59.9a.89.89,0,0,1-1.42,1,.89.89,0,0,1,.8-1.53v-.14a.87.87,0,0,1-.63-.22.9.9,0,0,1-.09-1.26.89.89,0,0,1,1.26-.07.9.9,0,0,1,.09,1.26h0c.15,0,.47-.16.94-1.12l.38.35c-.88.58-1,.92-1,1.07v0a.9.9,0,0,1,1.35,1.19A.89.89,0,0,1,60.34,135.34Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M63.45,131.81a.89.89,0,0,1-.3-.59H63a.87.87,0,0,1-.15.91.9.9,0,1,1-.46-1.46v-.13a.94.94,0,0,1-.63-.23A.89.89,0,1,1,62.94,129a.89.89,0,0,1,.08,1.26h0c.16,0,.47-.16.94-1.11l.39.34c-.89.59-1,.92-1,1.07h0a.9.9,0,1,1,.09,1.26Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M66.57,128.27a.9.9,0,0,1-.31-.59h-.13a.87.87,0,0,1-.16.91.9.9,0,1,1-.46-1.45V127a.87.87,0,0,1-.62-.23.89.89,0,0,1-.09-1.26.9.9,0,0,1,1.35,1.19v0c.15,0,.46-.17.94-1.12l.38.34c-.88.59-1,.92-1,1.07h0a.89.89,0,0,1,1.26-.07.9.9,0,0,1,.09,1.26A.89.89,0,0,1,66.57,128.27Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M69.68,124.73a.89.89,0,0,1-.3-.59h-.14a.91.91,0,0,1-.15.92.9.9,0,0,1-1.26.07.89.89,0,0,1,.8-1.53v-.14a.89.89,0,0,1-.63-.22A.9.9,0,0,1,67.9,122a.9.9,0,0,1,1.35,1.19h0c.15,0,.47-.16.94-1.12l.39.34c-.89.59-1,.92-1,1.08v0a.89.89,0,0,1,1.26-.07.9.9,0,0,1,.09,1.26A.89.89,0,0,1,69.68,124.73Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M72.79,121.2a.91.91,0,0,1-.3-.59h-.13a.9.9,0,1,1-.62-.55v-.14a.86.86,0,0,1-.62-.22.89.89,0,1,1,1.17-1.33.9.9,0,0,1,.09,1.26h0c.16,0,.47-.16.94-1.11l.39.34c-.88.59-1,.92-1,1.07h0a.9.9,0,0,1,1.26-.08.88.88,0,0,1,.09,1.26A.9.9,0,0,1,72.79,121.2Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M75.91,117.66a.89.89,0,0,1-.3-.59h-.14a.91.91,0,1,1-.61-.54l0-.14a.92.92,0,0,1-.62-.23.89.89,0,1,1,1.26-.07h0c.15,0,.47-.16.94-1.11l.39.34c-.89.59-1,.92-1,1.07h0a.89.89,0,0,1,1.26-.07.89.89,0,1,1-1.17,1.33Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-184",
    x1: 35.05,
    y1: 151.72,
    x2: 63.76,
    y2: 117.36
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M36.76,151.4a1,1,0,0,1-.33-.56H36.3a.77.77,0,0,1-.07.84.89.89,0,0,1-1.36-1.14.79.79,0,0,1,.82-.22l0-.13a1,1,0,0,1-.61-.22.79.79,0,1,1,1-1.2.84.84,0,0,1,.18,1.17h0c.14,0,.43-.14.8-1l.39.32c-.79.52-.87.82-.85,1h0a.89.89,0,1,1,.18,1.17Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M39.42,148.22a.92.92,0,0,1-.33-.55H39a.75.75,0,0,1-.08.84.82.82,0,0,1-1.17,0,.83.83,0,0,1-.19-1.16.76.76,0,0,1,.82-.22l0-.13a1,1,0,0,1-.61-.23.85.85,0,0,1-.18-1.17.9.9,0,0,1,1.37,1.14h0c.15,0,.43-.13.8-1l.39.33c-.78.52-.87.82-.85,1h0a.9.9,0,0,1,1.37,1.13A.83.83,0,0,1,39.42,148.22Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M42.07,145.05a1,1,0,0,1-.33-.56h-.13a.77.77,0,0,1-.07.84.89.89,0,0,1-1.36-1.14A.76.76,0,0,1,41,144l0-.13a1,1,0,0,1-.6-.22.79.79,0,1,1,1-1.2.85.85,0,0,1,.18,1.17h0c.14,0,.42-.14.79-1l.4.32c-.79.52-.88.82-.85,1h0a.89.89,0,1,1,.18,1.17Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M44.72,141.87a1,1,0,0,1-.33-.55h-.12a.79.79,0,0,1-.08.84A.89.89,0,0,1,42.83,141a.78.78,0,0,1,.82-.23l0-.12a1,1,0,0,1-.61-.23.84.84,0,0,1-.18-1.17.83.83,0,0,1,1.18,0,.82.82,0,0,1,.18,1.16h0c.15,0,.43-.13.8-1l.39.33c-.79.51-.87.82-.85,1h0a.83.83,0,0,1,1.18,0,.82.82,0,0,1,.18,1.16A.83.83,0,0,1,44.72,141.87Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M47.38,138.7a1,1,0,0,1-.33-.56h-.13a.77.77,0,0,1-.07.84.9.9,0,0,1-1.37-1.14.78.78,0,0,1,.82-.22l0-.13a.89.89,0,0,1-.6-.23.83.83,0,0,1-.19-1.16.9.9,0,0,1,1.37,1.14h0c.15,0,.43-.14.8-1l.39.33c-.78.52-.87.82-.84,1h0a.84.84,0,0,1,1.18,0,.85.85,0,0,1,.18,1.17A.84.84,0,0,1,47.38,138.7Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M50,135.52a1,1,0,0,1-.33-.55h-.13a.77.77,0,0,1-.07.84.89.89,0,0,1-1.36-1.14.79.79,0,0,1,.82-.22l0-.12a1,1,0,0,1-.6-.23.79.79,0,1,1,1-1.2.85.85,0,0,1,.18,1.17h0c.14,0,.43-.14.79-1l.4.33c-.79.51-.88.82-.85,1v0a.83.83,0,0,1,1.18,0,.82.82,0,0,1,.18,1.16A.84.84,0,0,1,50,135.52Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M52.68,132.35a1,1,0,0,1-.33-.56h-.12a.78.78,0,0,1-.08.84.9.9,0,0,1-1.36-1.14.77.77,0,0,1,.82-.22l0-.13a.91.91,0,0,1-.61-.23.78.78,0,1,1,1-1.19.82.82,0,0,1,.18,1.16v0c.14,0,.43-.14.8-1l.39.33c-.79.52-.87.82-.85,1h0a.89.89,0,1,1,.18,1.17Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M55.34,129.17a.92.92,0,0,1-.33-.55h-.13a.77.77,0,0,1-.07.84.89.89,0,0,1-1.36-1.14.78.78,0,0,1,.81-.22l0-.13a1,1,0,0,1-.6-.22.78.78,0,1,1,1-1.2.85.85,0,0,1,.19,1.17h0c.14,0,.42-.14.79-1l.39.32c-.78.52-.87.83-.84,1v0a.9.9,0,0,1,1.36,1.14A.84.84,0,0,1,55.34,129.17Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M58,126a1,1,0,0,1-.33-.55h-.13a.76.76,0,0,1-.07.83.89.89,0,0,1-1.36-1.13.77.77,0,0,1,.82-.22l0-.13a1,1,0,0,1-.61-.23.82.82,0,0,1-.18-1.16.89.89,0,0,1,1.36,1.13h0c.14,0,.43-.13.8-1l.39.33c-.79.52-.87.82-.85,1h0A.89.89,0,0,1,59.17,126,.83.83,0,0,1,58,126Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M60.65,122.82a.87.87,0,0,1-.33-.55h-.13a.77.77,0,0,1-.08.84.84.84,0,0,1-1.18,0,.85.85,0,0,1-.18-1.17.8.8,0,0,1,.82-.22l0-.13a1,1,0,0,1-.61-.22.85.85,0,0,1-.18-1.17.9.9,0,0,1,1.37,1.14h0c.15,0,.43-.14.8-1l.39.32c-.79.52-.87.82-.85,1v0a.9.9,0,1,1,.19,1.17Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M63.3,119.64a1,1,0,0,1-.33-.55h-.13a.76.76,0,0,1-.07.83.83.83,0,0,1-1.18,0,.82.82,0,0,1-.18-1.16.74.74,0,0,1,.81-.22l0-.13a1,1,0,0,1-.6-.23.78.78,0,1,1,1-1.19.84.84,0,0,1,.18,1.16h0c.14,0,.42-.13.79-1l.4.33c-.79.52-.88.82-.85,1h0a.83.83,0,0,1,1.18,0,.85.85,0,0,1,.18,1.17A.84.84,0,0,1,63.3,119.64Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.42 115.18 109.75 174.76 111.25 175.26 134.17 115.68 132.42 115.18"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M123.08,123.16l-9.2,11.49,3.52,2.17a15.32,15.32,0,0,1,3.77,4.42c.34.68,2.32-.07.61-3l-1.39-2.85,6.45,5.31s3.54,3.21,3.69,1.73c.1-.94-1.29-2.86-1.88-3.26s-4.88-5.44-4.88-5.44l5.24,3.93s3.88,3.19,4.21,2.66c1.25-2-1.3-3.76-2-4.21s-5.79-5-5.79-5l6.88,3.87s2.63,1.89,2.82,1.17c.46-1.76-1.39-3-1.77-3.21-.69-.4-5.82-3.81-5.82-3.81l1.81.25s5.3,1.92,5.34,1.45c.19-2.29-9.33-6.27-9.33-6.27A22.21,22.21,0,0,0,123.08,123.16Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-216",
    points: "84.09 121.56 113.5 137.42 134.08 108.32 90.24 112.98 84.26 120.76"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.5 137.42 109.84 135.26 128.71 109.14 134.08 108.32 113.5 137.42"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M113.18,135.58a.81.81,0,0,1-.31-.45h-.11a.67.67,0,0,1,0,.72.76.76,0,0,1-1.22-.89.67.67,0,0,1,.68-.24l0-.1a.81.81,0,0,1-.53-.16.67.67,0,1,1,1-.09h0c.12,0,.35-.14.62-.9l.35.25c-.64.49-.7.75-.67.87h0a.76.76,0,1,1,.22,1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M115.26,132.73a.8.8,0,0,1-.31-.46l-.11,0a.67.67,0,0,1,0,.72.76.76,0,0,1-1.22-.9.64.64,0,0,1,.68-.23l0-.11a.81.81,0,0,1-.53-.16.67.67,0,1,1,1-.09h0c.13,0,.36-.14.62-.9l.36.26c-.64.48-.7.75-.67.87v0a.72.72,0,0,1,1-.09.67.67,0,1,1-.78,1.08Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M117.34,129.87a.76.76,0,0,1-.31-.45h-.11a.67.67,0,0,1,0,.72.76.76,0,0,1-1.22-.89.67.67,0,0,1,.68-.24l0-.1a.81.81,0,0,1-.53-.16.67.67,0,1,1,1-.09h0c.12,0,.36-.14.62-.9l.35.26c-.64.48-.69.74-.66.86h0a.76.76,0,1,1,.22,1Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M119.42,127a.82.82,0,0,1-.32-.45H119a.65.65,0,0,1,0,.72.77.77,0,0,1-1.23-.89.69.69,0,0,1,.69-.24l0-.11a.8.8,0,0,1-.54-.16.71.71,0,0,1-.21-1,.76.76,0,0,1,1.22.89h0c.12,0,.36-.14.62-.9l.35.26c-.64.49-.69.75-.66.87h0a.7.7,0,0,1,1-.09.67.67,0,1,1-.78,1.07Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M121.5,124.16a.75.75,0,0,1-.32-.45h-.11a.65.65,0,0,1,0,.72.76.76,0,0,1-1.22-.89.64.64,0,0,1,.68-.23l0-.11a.84.84,0,0,1-.53-.16.73.73,0,0,1-.22-1A.77.77,0,0,1,121,123h0c.12,0,.35-.14.62-.9l.35.26c-.64.48-.69.74-.67.86h0a.72.72,0,0,1,1-.09.73.73,0,0,1,.22,1A.71.71,0,0,1,121.5,124.16Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M123.57,121.31a.81.81,0,0,1-.31-.45h-.11a.67.67,0,0,1,0,.72.74.74,0,0,1-1,.09.73.73,0,0,1-.22-1,.68.68,0,0,1,.69-.24l0-.11a.81.81,0,0,1-.53-.15.74.74,0,0,1-.22-1,.77.77,0,0,1,1.23.9h0c.12,0,.35-.14.62-.89l.35.25c-.64.49-.7.75-.67.87h0a.77.77,0,0,1,1.23.89A.73.73,0,0,1,123.57,121.31Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M125.65,118.46a.83.83,0,0,1-.31-.46l-.11,0a.63.63,0,0,1,0,.71.7.7,0,0,1-1,.09.71.71,0,0,1-.22-1,.64.64,0,0,1,.68-.23l0-.11a.81.81,0,0,1-.53-.16.67.67,0,1,1,1-.09h0c.12,0,.35-.14.62-.9l.35.26c-.64.48-.7.75-.67.86h0a.72.72,0,0,1,1-.09.67.67,0,1,1-.78,1.08Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M127.73,115.6a.81.81,0,0,1-.31-.45h-.11a.65.65,0,0,1,0,.72.76.76,0,0,1-1.22-.89.67.67,0,0,1,.68-.24l0-.1a.81.81,0,0,1-.53-.16.67.67,0,1,1,1-.09h0c.12,0,.35-.14.61-.9l.36.25c-.64.49-.7.75-.67.87h0a.76.76,0,1,1,.22,1Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M129.81,112.75a.75.75,0,0,1-.31-.46l-.11,0a.67.67,0,0,1,0,.72.76.76,0,0,1-1.22-.9.64.64,0,0,1,.68-.23l0-.11a.81.81,0,0,1-.53-.16.67.67,0,1,1,1-.09h0c.12,0,.36-.14.62-.9l.36.26c-.65.49-.7.75-.67.87v0a.76.76,0,1,1,.22,1Z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "131.25 123.1 136.42 121.93 139.75 114.26 134.17 115.68 131.25 123.1"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "129.59 122.6 127.25 118.26 130.81 112.66 132.42 115.18 129.59 122.6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M108.25,181.26s6-3,8.5-8.33l-6,1.5-3-4.17S105.92,174.76,108.25,181.26Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11C);
export default __webpack_public_path__ + "static/media/11_c.98940e28c7a5ba6f2c1c26e5668dda22.svg";
export { ForwardRef as ReactComponent };